// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topnav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #0d0d0d;
  padding: 15px 30px;
  color: #f2f2f2;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  position: relative;
  z-index: 1000;
}

.topnav .logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.topnav .logo img {
  height: 50px;
  width: auto;
}

.topnav .logo a {
  display: flex;
  align-items: center;
  gap: 12px; /* increase or decrease this for more/less spacing */
}

.topnav a {
  text-decoration: none;
}

.topnav .logo span {
  font-size: 1.3rem;
  font-weight: bold;
  color: #f7931a;
}

/* Desktop nav */
.topnav nav {
  display: flex;
  gap: 20px;
}

.topnav nav a {
  color: #ccc;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.2s ease;
}

.topnav nav a:hover {
  color: #f7931a;
}

/* Hamburger menu button - hidden on desktop */
.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 25px;
  height: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1100;
}

.menu-toggle .bar {
  height: 3px;
  width: 100%;
  background-color: #f7931a;
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* Hamburger open state animation */
.menu-toggle.open .bar:nth-child(1) {
  transform: translateY(8.5px) rotate(45deg);
}

.menu-toggle.open .bar:nth-child(2) {
  opacity: 0;
}

.menu-toggle.open .bar:nth-child(3) {
  transform: translateY(-8.5px) rotate(-45deg);
}

/* Responsive */
@media (max-width: 600px) {
  .topnav {
    padding: 15px 20px;
  }

  /* Show hamburger button */
  .menu-toggle {
    display: flex;
  }

  /* Hide nav by default */
  .topnav nav {
    position: absolute;
    top: 60px; /* height of header + some space */
    right: 0;
    background-color: #0d0d0d;
    flex-direction: column;
    width: 180px;
    padding: 15px 20px;
    box-shadow: 0 4px 15px rgba(247, 147, 26, 0.8);
    border-radius: 0 0 0 8px;
    opacity: 0;
    pointer-events: none;
    transform: translateY(-10px);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  /* Show nav when open */
  .topnav nav.open {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }

  .topnav nav a {
    padding: 10px 0;
    font-size: 1.1rem;
    color: #f2f2f2;
    border-bottom: 1px solid #333;
  }

  .topnav nav a:last-child {
    border-bottom: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/css/TopNav.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,4DAA4D;EAC5D,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,oDAAoD;AACjE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA,0BAA0B;EAC1B;IACE,aAAa;EACf;;EAEA,wBAAwB;EACxB;IACE,kBAAkB;IAClB,SAAS,EAAE,kCAAkC;IAC7C,QAAQ;IACR,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,8CAA8C;IAC9C,wBAAwB;IACxB,UAAU;IACV,oBAAoB;IACpB,4BAA4B;IAC5B,kDAAkD;EACpD;;EAEA,uBAAuB;EACvB;IACE,UAAU;IACV,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".topnav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #0d0d0d;\n  padding: 15px 30px;\n  color: #f2f2f2;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  position: relative;\n  z-index: 1000;\n}\n\n.topnav .logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.topnav .logo img {\n  height: 50px;\n  width: auto;\n}\n\n.topnav .logo a {\n  display: flex;\n  align-items: center;\n  gap: 12px; /* increase or decrease this for more/less spacing */\n}\n\n.topnav a {\n  text-decoration: none;\n}\n\n.topnav .logo span {\n  font-size: 1.3rem;\n  font-weight: bold;\n  color: #f7931a;\n}\n\n/* Desktop nav */\n.topnav nav {\n  display: flex;\n  gap: 20px;\n}\n\n.topnav nav a {\n  color: #ccc;\n  text-decoration: none;\n  font-size: 1rem;\n  transition: color 0.2s ease;\n}\n\n.topnav nav a:hover {\n  color: #f7931a;\n}\n\n/* Hamburger menu button - hidden on desktop */\n.menu-toggle {\n  display: none;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 25px;\n  height: 20px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 1100;\n}\n\n.menu-toggle .bar {\n  height: 3px;\n  width: 100%;\n  background-color: #f7931a;\n  border-radius: 2px;\n  transition: all 0.3s ease;\n}\n\n/* Hamburger open state animation */\n.menu-toggle.open .bar:nth-child(1) {\n  transform: translateY(8.5px) rotate(45deg);\n}\n\n.menu-toggle.open .bar:nth-child(2) {\n  opacity: 0;\n}\n\n.menu-toggle.open .bar:nth-child(3) {\n  transform: translateY(-8.5px) rotate(-45deg);\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .topnav {\n    padding: 15px 20px;\n  }\n\n  /* Show hamburger button */\n  .menu-toggle {\n    display: flex;\n  }\n\n  /* Hide nav by default */\n  .topnav nav {\n    position: absolute;\n    top: 60px; /* height of header + some space */\n    right: 0;\n    background-color: #0d0d0d;\n    flex-direction: column;\n    width: 180px;\n    padding: 15px 20px;\n    box-shadow: 0 4px 15px rgba(247, 147, 26, 0.8);\n    border-radius: 0 0 0 8px;\n    opacity: 0;\n    pointer-events: none;\n    transform: translateY(-10px);\n    transition: opacity 0.3s ease, transform 0.3s ease;\n  }\n\n  /* Show nav when open */\n  .topnav nav.open {\n    opacity: 1;\n    pointer-events: auto;\n    transform: translateY(0);\n  }\n\n  .topnav nav a {\n    padding: 10px 0;\n    font-size: 1.1rem;\n    color: #f2f2f2;\n    border-bottom: 1px solid #333;\n  }\n\n  .topnav nav a:last-child {\n    border-bottom: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
